// extracted by mini-css-extract-plugin
export default {"container":"Appetizers_container__71YXH"};